(function () {
    if (window.EEGVariantController) return;

    const parseJson = (element) => {
        if (!element) return null;
        try {
            return JSON.parse(element.textContent);
        } catch (error) {
            return null;
        }
    };

    const create = (config) => {
        if (!config) return null;

        const variants = Array.isArray(config.variants) ? config.variants : [];
        const variantPriceMap = config.variantPriceMap instanceof Map ? config.variantPriceMap : new Map();
        const variantCartMap = config.variantCartMap instanceof Map ? config.variantCartMap : new Map();
        const optionGroups = config.optionGroups ? Array.from(config.optionGroups) : [];
        const optionInputSelector = config.optionInputSelector || 'input[type="radio"]';
        const optionValueSelector = config.optionValueSelector || '';
        const variantIdInput = config.variantIdInput || null;
        const priceEl = config.priceEl || null;
        const comparePriceEl = config.comparePriceEl || null;
        const addToCartBtn = config.addToCartBtn || null;
        const addToCartLabel = config.addToCartLabel || null;
        const addToCartText = config.addToCartText || '';
        const soldOutText = config.soldOutText || '';
        const inventoryEl = config.inventoryEl || null;
        const inventoryThreshold = Number(config.inventoryThreshold || 5);
        const inventoryStrings = config.inventoryStrings || {};
        const quantityNote = config.quantityNote || null;
        const onVariantChange = typeof config.onVariantChange === 'function' ? config.onVariantChange : null;

        const getSelectedOptions = () => {
            return optionGroups.map((group) => {
                const selected = group.querySelector(`${optionInputSelector}:checked`);
                return selected ? selected.value : null;
            });
        };

        const findMatchingVariant = (selectedOptions) => {
            return variants.find((variant) => {
                if (!variant || !variant.options) {
                    return false;
                }
                return variant.options.every((option, index) => option === selectedOptions[index]);
            });
        };

        const updateInventoryStatus = (variantData) => {
            if (!inventoryEl || !variantData) {
                return;
            }
            inventoryEl.classList.remove('is-in', 'is-low', 'is-backorder', 'is-out');
            const inventoryQuantity = Number(variantData.inventoryQuantity || 0);
            const isTracked = Boolean(variantData.inventoryManagement);

            if (!variantData.available) {
                inventoryEl.textContent = inventoryStrings.outOfStock || 'Sold Out';
                inventoryEl.classList.add('is-out');
                return;
            }

            if (isTracked && inventoryQuantity <= 0) {
                inventoryEl.textContent = inventoryStrings.backorder || 'Backorder Available';
                inventoryEl.classList.add('is-backorder');
                return;
            }

            if (isTracked && inventoryQuantity > 0 && inventoryQuantity <= inventoryThreshold) {
                const lowStockTemplate = inventoryStrings.lowStock || 'Only {count} left';
                inventoryEl.textContent = lowStockTemplate.replace('{count}', inventoryQuantity);
                inventoryEl.classList.add('is-low');
                return;
            }

            inventoryEl.textContent = inventoryStrings.inStock || 'In Stock';
            inventoryEl.classList.add('is-in');
        };

        const updatePriceAndAvailability = (variantId) => {
            const variantData = variantPriceMap.get(String(variantId));
            if (!variantData) {
                return;
            }
            if (priceEl) {
                priceEl.textContent = variantData.price;
            }
            if (comparePriceEl) {
                if (variantData.compareAtPrice) {
                    comparePriceEl.textContent = variantData.compareAtPrice;
                    comparePriceEl.classList.remove('is-hidden');
                } else {
                    comparePriceEl.textContent = '';
                    comparePriceEl.classList.add('is-hidden');
                }
            }
            if (addToCartBtn) {
                addToCartBtn.disabled = !variantData.available;
                if (variantData.available) {
                    addToCartBtn.removeAttribute('aria-disabled');
                } else {
                    addToCartBtn.setAttribute('aria-disabled', 'true');
                }
            }
            if (addToCartLabel) {
                addToCartLabel.textContent = variantData.available
                    ? addToCartText || addToCartLabel.textContent
                    : soldOutText || addToCartLabel.textContent;
            }
            updateInventoryStatus(variantData);
        };

        const updateOptionAvailability = (selectedOptions) => {
            optionGroups.forEach((group, groupIndex) => {
                const inputs = group.querySelectorAll(optionInputSelector);
                inputs.forEach((input) => {
                    let isValid = false;
                    let hasAvailableVariant = false;

                    variants.forEach((variant) => {
                        if (!variant || !variant.options) return;

                        const matches = variant.options.every((option, index) => {
                            if (index === groupIndex) {
                                return option === input.value;
                            }
                            const selectedValue = selectedOptions[index];
                            return selectedValue ? option === selectedValue : true;
                        });

                        if (matches) {
                            isValid = true;
                            if (variant.available) {
                                hasAvailableVariant = true;
                            }
                        }
                    });

                    input.disabled = !isValid;
                    input.setAttribute('aria-disabled', String(!isValid));

                    if (optionValueSelector) {
                        const optionValue = input.closest(optionValueSelector);
                        if (optionValue) {
                            optionValue.classList.toggle('is-disabled', !isValid);
                            optionValue.classList.toggle('is-out-of-stock', isValid && !hasAvailableVariant);
                        }
                    }
                });
            });
        };

        const updateQuantityNote = (variantId) => {
            if (!quantityNote) return;
            if (!variantId) {
                quantityNote.textContent = '';
                quantityNote.hidden = true;
                return;
            }
            const qty = Number(variantCartMap.get(String(variantId)) || 0);
            if (qty > 0) {
                quantityNote.textContent = `(${qty} in cart)`;
                quantityNote.hidden = false;
            } else {
                quantityNote.textContent = '';
                quantityNote.hidden = true;
            }
        };

        const updateCartFromCart = (cart) => {
            if (!cart || !Array.isArray(cart.items)) return;
            variantCartMap.clear();
            cart.items.forEach((item) => {
                const key = String(item.variant_id);
                const current = variantCartMap.get(key) || 0;
                variantCartMap.set(key, current + item.quantity);
            });
            if (variantIdInput) {
                updateQuantityNote(variantIdInput.value);
            }
        };

        const updateSelection = () => {
            if (!variants.length || !optionGroups.length) {
                return;
            }
            const selectedOptions = getSelectedOptions();
            updateOptionAvailability(selectedOptions);
            if (selectedOptions.includes(null)) {
                return;
            }
            const matchedVariant = findMatchingVariant(selectedOptions);
            if (!matchedVariant) {
                return;
            }
            if (variantIdInput) {
                variantIdInput.value = matchedVariant.id;
            }
            updatePriceAndAvailability(matchedVariant.id);
            updateQuantityNote(matchedVariant.id);
            if (onVariantChange) {
                onVariantChange(matchedVariant);
            }
        };

        return {
            updateSelection,
            updateCartFromCart,
            updateQuantityNote,
            getSelectedOptions,
            findMatchingVariant,
        };
    };

    window.EEGVariantController = {
        create,
        parseJson,
    };
})();
